import React from 'react';
import { Typography } from '@mui/material';

const SectionLabel = ({ children }) => (
    <Typography
        variant="caption"
        sx={{
            display: 'inline-block',
            px: 1,
            py: 0.25,
            mb: 1,
            borderRadius: 1.5,
            fontWeight: 700,
            color: 'text.primary',
            bgcolor: 'background.paper',
            border: (t) => `1px solid ${t.palette.divider}`,
        }}
    >
        {children}
    </Typography>
);

export default SectionLabel;
